import request from '@/modules/base/util/request'
import { toast } from '@/modules/base/components/toast/toastConfig'

import lang from '@/lang'
import { urls } from '@/modules/banking/config'

import { startAccountCheckPollRequest } from '@/redux/ducks/banking/_helpers/startAccountCheckPollRequest'
import {
  fetchBankAccountList as reloadBankAccountList,
  selectBankAccount as selectBankAccountInList,
} from '@/redux/ducks/banking/bankAccountList'
import {
  fetchList as reloadAccountBookings,
} from '@/redux/ducks/lists/requests/turnoverList'
import startContactSyncPollRequest from './_helpers/startContactSyncPollRequest'

// #region Actions
const ACTION_PREFIX = 'banking/bankContactSettings'
const SET_BANKCONTACT_SETTINGS = `${ACTION_PREFIX}/setBankContactSettings`
const SHOW_BANKCONTACT_SETTINGS = `${ACTION_PREFIX}/showBankContactSettings`
const HIDE_BANKCONTACT_SETTINGS_UI = `${ACTION_PREFIX}/hideBankkontactSettingsUi`
const SET_LINKED_BANKACCOUNTS = `${ACTION_PREFIX}/setLinkedBankAccounts`
const LOAD_SETTINGS = `${ACTION_PREFIX}/loadSettings`
const SET_SECONDARY_ACTION_ISRUNNING = `${ACTION_PREFIX}/setActionIsRunning`
// #endregion

// #region Reducer
const initialState = {
  bankAccountId: null,
  contactId: null,
  data: {},
  loadSettings: false,
  showSettingsUi: false,
  doFetchLinkedBankAccounts: false,
  actionIsRunning: false,
  linkedBankAccounts: [],
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_BANKCONTACT_SETTINGS: {
      return {
        ...state,
        loadSettings: false,
        data: action.data,
      }
    }
    case LOAD_SETTINGS: {
      return {
        ...state,
        loadSettings: action.loadSettings,
      }
    }
    case SHOW_BANKCONTACT_SETTINGS: {
      return {
        ...state,
        bankAccountId: action.accountId,
        contactId: action.contactId,
        data: {},
        showSettingsUi: true,
        loadSettings: true,
        doFetchLinkedBankAccounts: true,
      }
    }
    case HIDE_BANKCONTACT_SETTINGS_UI: {
      return {
        ...state,
        showSettingsUi: false,
        contactId: null,
        bankAccountId: null,
      }
    }
    case SET_LINKED_BANKACCOUNTS: {
      return {
        ...state,
        linkedBankAccounts: action.bankAccounts,
        doFetchLinkedBankAccounts: false,
      }
    }
    case SET_SECONDARY_ACTION_ISRUNNING: {
      return {
        ...state,
        actionIsRunning: action.isRunning,
      }
    }
    default: {
      return state
    }
  }
}
// #endregion

// #region Action Creators
export const setBankContactSettings = (bankContactDetailData) => ({ type: SET_BANKCONTACT_SETTINGS, data: bankContactDetailData })
export const showBankContactSettings = ({ contactId, accountId }) => ({ type: SHOW_BANKCONTACT_SETTINGS, contactId, accountId })
export const hideBankContactSettingsUi = () => ({ type: HIDE_BANKCONTACT_SETTINGS_UI })
export const setLinkedBankAccounts = (bankAccounts) => ({ type: SET_LINKED_BANKACCOUNTS, bankAccounts })
export const loadBankContactSettings = () => ({ type: LOAD_SETTINGS, loadSettings: true })
export const setActionIsRunning = (isRunning) => ({ type: SET_SECONDARY_ACTION_ISRUNNING, isRunning })
export const fetchLinkedBankAccounts = () => {
  return (dispatch, getState) => {
    const {
      banking: { bankContactSettings: { contactId } },
    } = getState()

    if (contactId) {
      request(urls.fetchAvailableBankAccountsForContact(contactId), {
        auth: true,
        isConcurrent: true,
      })
        .then(({ body: { data } }) => {
          const selectedBankAccounts = (data.bankAccounts || [])
            .filter(ba => ba.accountActive)
            .map(bankAccount => {
              const { id, contactId, accountName, bicCode, bankName, accountIban, accountType } = bankAccount
              return {
                id,
                contactId,
                accountName,
                bicCode,
                bankName,
                accountIban,
                accountType,
              }
            })
          dispatch(setLinkedBankAccounts(selectedBankAccounts))
        })
        .catch(error => {
          toast.showToast({ error })
        })
    }
  }
}
export const deleteBankContact = (requestData) => {
  return (dispatch) => {
    dispatch(setActionIsRunning(true))
    requestData.showOnlyBankName = true
    const { contactId: bankingContactId } = requestData
    request(urls.deleteBankContact(bankingContactId), {
      auth: true,
      method: 'DELETE',
    })
      .then(() => {
        toast.showToast({ message: lang.bankingDeleteBankContactSuccessMessage, bankAccountInfo: requestData })
        dispatch(hideBankContactSettingsUi())
        dispatch(reloadBankAccountList())
      })
      .catch(error => toast.showToast({ error, bankAccountInfo: requestData, message: lang.bankingDeleteBankContactErrorMessage }))
      .finally(() => dispatch(setActionIsRunning(false)))
  }
}
export const doAccountCheck = (requestData) => {
  return (dispatch, getState) => {
    const {
      banking: { bankAccountList: { bankAccounts: bankAccountsInList } },
    } = getState()

    dispatch(setActionIsRunning(true))
    const { accountId, accountType, accountName } = requestData
    startAccountCheckPollRequest(accountId)
      .then(() => {
        return dispatch(reloadBankAccountList())
      })
      .then((bankAccounts) => {
        const currSelectedAccount = bankAccountsInList.find(b => b.id === accountId) // reselect from state to get the account in expected structure for dispatching
        dispatch(selectBankAccountInList(currSelectedAccount))
        dispatch(reloadAccountBookings(accountId, accountType))
        toast.showToast({ message: lang.bankingAccountCheckSuccessMessage(accountName), bankAccountInfo: requestData })
      })
      .catch((error) => {
        toast.showToast({ error, requestData, message: lang.bankingAccountCheckErrorMessage })
      })
      .finally(() => {
        dispatch(setActionIsRunning(false))
      })
  }
}
export const doContactSync = (requestData) => {
  return (dispatch) => {
    dispatch(setActionIsRunning(true))
    const { contactId, bankName } = requestData
    startContactSyncPollRequest(contactId)
      .then(() => {
        return dispatch(reloadBankAccountList())
      })
      .then(() => {
        toast.showToast({ message: lang.bankingContactSyncSuccessful(bankName) })
      })
      .catch((error) => {
        toast.showToast({ error, requestData, message: lang.bankingAccountCheckErrorMessage })
      })
      .finally(() => {
        dispatch(setActionIsRunning(false))
      })
  }
}
// #endregion
